import React from "react";

import { Link } from "gatsby-plugin-intl";
const helpers = require("../../helpers");

import "../../scss/molecules/_link-list.scss";

class LinkListItem extends React.Component {
  render() {
    return (
      <li className="link-list-item">
        <Link to={helpers.getTrailedUrl(this.props.to)}>
          {this.props.children}
        </Link>
      </li>
    );
  }
}

export default LinkListItem;
